<template>
  <div>
    <v-list-item>
      <v-list-item-avatar
        ><v-icon>mdi-bucket-outline</v-icon></v-list-item-avatar
      >
      <v-list-item-content>
        <v-list-item-title class="font-italic grey--text">
          Vaso Ø {{ categ.diametro }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon color="grey" @click="show = !show"
          ><v-icon>{{
            show ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon></v-btn
        >
      </v-list-item-action>
    </v-list-item>
    <template v-if="show">
      <template v-for="prod in categ.prodotti">
        <ElementoProdotto
          :prodotto="prod"
          :key="prod.id"
          :cliente="cliente"
          :anno_rif="anno_rif"
        />
       
      </template>
    </template>
     <v-divider/>
  </div>
</template>

<script>
import ElementoProdotto from "./elemento_prodotto_nuovo_ordine.vue";
export default {
  components: {
    ElementoProdotto,
  },
  props: {
    categ: Object,
    cliente: String,
    anno_rif: String,
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>